export const summaryFields = {
  valuePerDay: [
    {
      id: "count",
      label: "Total # Sold",
    },
    {
      id: "total",
      label: "Total $ Sold",
      prefix: "$",
      precision: 2,
    },
    {
      id: "min",
      label: "Lowest Sale",
      prefix: "$",
      precision: 2,
    },
    {
      id: "max",
      label: "Highest Sale",
      prefix: "$",
      precision: 2,
    },
  ],
  numberOfSales: [
    {
      id: "count",
      label: "Total # Sold",
    },
    {
      id: "total",
      label: "Total $ Sold",
      prefix: "$",
      precision: 2,
    },
    {
      id: "minCount",
      label: "Lowest Sale Count (per day)",
    },
    {
      id: "maxCount",
      label: "Highest Sale Count (per day)",
    },
  ],
  totalSales: [
    {
      id: "total",
      label: "Total $ Sold",
      prefix: "$",
      precision: 2,
    },
  ],
  endAvgPerEntity: [
    {
      id: "count",
      label: "Total # Sold",
    },
    {
      id: "total",
      label: "Total $ Sold",
      prefix: "$",
      precision: 2,
    },
    {
      id: "min",
      label: "Lowest Sale",
      prefix: "$",
      precision: 2,
    },
    {
      id: "max",
      label: "Highest Sale",
      prefix: "$",
      precision: 2,
    },
  ],
  percentageGrowthChart: [
    {
      id: "count",
      label: "Total # Sold",
    },
    {
      id: "total",
      label: "Total $ Sold",
      prefix: "$",
      precision: 2,
    },
    {
      id: "minPercentChange",
      label: "Lowest Percentage Change",
      suffix: "%",
      precision: 2,
    },
    {
      id: "maxPercentChange",
      label: "Highest Percentage Change",
      suffix: "%",
      precision: 2,
    },
  ],
};

export const cardStatsInfoText = "For individual Card performance, see the Stats section below.";

export const sealedWaxStatsInfoText = "For individual Wax performance, see the Stats section below.";
